import { Component, Input, Output, EventEmitter } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CardModule } from 'primeng/card'

/** Intervention programmée proche de la ville recherchée. */
export interface NearbyIntervention {
  id: number | null
  title: string
  dateLabel: string
  technicianName: string | null
  /** "CP Ville" du chantier. */
  location: string
  distanceKm: number
  /** Distance formatée ("3,2 km", "27 km"). */
  distanceLabel: string
  latitude: number
  longitude: number
}

/**
 * Panneau « Interventions proches » : remplace le panneau « Sans créneau »
 * quand une ville a été recherchée sur la carte. Liste les interventions
 * programmées autour de la ville, triées par distance.
 */
@Component({
  selector: 'app-pool-nearby-interventions',
  standalone: true,
  imports: [CommonModule, CardModule],
  templateUrl: './pool-nearby-interventions.component.html',
  styleUrl: './pool-nearby-interventions.component.scss',
})
export class PoolNearbyInterventionsComponent {
  @Input() cityName = ''
  @Input() interventions: NearbyIntervention[] = []
  @Input() radiusKm = 50
  @Input() selectedInterventionId: number | null = null
  @Input() loading = false

  @Output() interventionSelected = new EventEmitter<NearbyIntervention>()
  @Output() closed = new EventEmitter<void>()
}
